<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        :title="`${id ? 'Edição' : 'Cadastro'} de logradouro`"
        large
        ref="Modal"
        @save="$refs.Form.save()"
    >
        <Form
            :id="id"
            ref="Form"
            @save="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open(id) {

            this.id = id

            this.$refs.Modal.show()
        },
        handleExit(logradouro) {

            this.$emit('save', logradouro)

            this.$refs.Modal.hide()
        },
    },
}
</script>